// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны

export interface IPriceForMobileSiteSchema {
  /** Валюта **/
  currency: ECurrency;
  /** Сутки, месяц **/
  period?: EPeriod;
  /** Цена, число **/
  value: number;
}

export enum ECurrency {
  /** € **/
  'Eur' = 'eur',
  /** ₽ **/
  'Rur' = 'rur',
  /** $ **/
  'Usd' = 'usd',
}
export enum EPeriod {
  /** В сутки **/
  'Day' = 'day',
  /** В месяц **/
  'Month' = 'month',
}
